import {
  SYSTEM_ROLES,
  SYSTEM_ROLE_LABELS,
  SYSTEM_ROLE_ADMIN,
  SYSTEM_ROLE_INTERNAL,
  SYSTEM_ROLE_EXTERNAL,
} from "./systemRoles";

const PROJECT_ROLES = [
  "project_manager",
  "qa_qc_manager",
  "inspector",
  "contractor",
  "client",
  "safety_officer",
  "site_supervisor",
  "foreman",
];

const EMPTY_NEW_USER = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  company: "",
  role: "user_internal",
  cognito_sub: "",
  is_active: true,
};

const BACKEND_PROJECT_PERMISSION_SCHEMA = {
  analytics: ["view"],
  daily_reports: ["create", "update"],
  documents: ["upload", "read", "delete"],
  findings: ["create", "read", "update", "close", "delete"],
  inspections: ["create", "update", "approve", "reject", "reopen", "delete"],
  materials: ["deliver"],
  ncr: ["create", "assign", "respond", "approve", "close"],
  photos: ["upload", "read", "delete"],
  project: ["update"],
  rfi: ["create"],
  safety: ["create", "read"],
  submittals: ["create", "approve"],
};

const DEFAULT_PROJECT_ROLE_PERMISSIONS = {
  project_manager: {
    project: ["update"],
    analytics: ["view"],
    inspections: ["reopen", "update"],
    findings: ["create", "update", "close", "delete"],
    documents: ["upload", "read", "delete"],
    photos: ["upload", "read", "delete"],
    daily_reports: ["create", "update"],
    submittals: ["create", "approve"],
    safety: ["read"],
    rfi: ["create"],
    ncr: ["assign", "approve", "close"],
  },
  qa_qc_manager: {
    analytics: ["view"],
    inspections: ["approve", "reject"],
    findings: ["create", "update", "close", "delete"],
    documents: ["upload", "read"],
    photos: ["read", "delete"],
    submittals: ["approve"],
    safety: ["read"],
    ncr: ["assign", "approve", "close"],
  },
  inspector: {
    inspections: ["create", "update", "reopen"],
    findings: ["create", "update", "close", "delete"],
    documents: ["upload", "read"],
    photos: ["upload", "read"],
    daily_reports: ["create", "update"],
    rfi: ["create"],
    ncr: ["create"],
    safety: ["create", "read"],
  },
  contractor: {
    materials: ["deliver"],
    ncr: ["respond"],
    rfi: ["create"],
    submittals: ["create"],
    documents: ["upload", "read"],
    photos: ["upload", "read"],
  },
  client: {
    analytics: ["view"],
    documents: ["read"],
    photos: ["read"],
    safety: ["read"],
  },

  admin: "ALL",
};

export {
  SYSTEM_ROLES,
  SYSTEM_ROLE_LABELS,
  SYSTEM_ROLE_ADMIN,
  SYSTEM_ROLE_INTERNAL,
  SYSTEM_ROLE_EXTERNAL,
  PROJECT_ROLES,
  BACKEND_PROJECT_PERMISSION_SCHEMA,
  DEFAULT_PROJECT_ROLE_PERMISSIONS,
  EMPTY_NEW_USER,
};
